import * as React from 'react';
import { connect } from 'react-redux';
import { find } from 'lodash';
import { Link } from 'react-router-dom';
import { getVehicle, getRevision } from '../../redux/actions/vehicles';
import conditions from '../../data/conditions';

import {
  IconButton,
  Notification,
  HeadingSection,
  NoteList,
  Permission,
  RouteWrapper,
  VehicleUpdateForm,
  Section,
  Loader,
} from '../../components';

interface Props {
  isFetching: boolean;
  error: any;
  match: any;
  vehicles: any;
  lastVehicle: any;
  dispatch: Function;
}

interface State {
  id: number;
  revisionId?: number;
  vehicle: any;
  ready: boolean;
}

class Route extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    const id = parseInt(this.props.match.params.id, 10);
    const revisionId = Number(this.props.match.params.revisionId);
    this.state = {
      id,
      revisionId,
      vehicle: false,
      ready: false,
    };
    this.renderCondition = this.renderCondition.bind(this);
  }

  /**
   * Load vehicle and list of vehicle types from API
   */
  async componentDidMount() {
    if (this.state.revisionId) {
      const revision = await this.props.dispatch(
        getRevision(this.state.id, this.state.revisionId),
      );
      this.setState({
        vehicle: revision.data,
        ready: true,
      });
      return;
    }

    const response = await this.props.dispatch(getVehicle(this.state.id));
    this.setState({
      vehicle: response.data,
      ready: true,
    });
  }

  /**
   * Render respective notification for vehicle condition
   */
  renderCondition() {
    const condition = find(conditions, {
      value: parseInt(this.state.vehicle.condition, 10),
    });
    if (this.state.vehicle.condition > 0 && condition !== undefined) {
      return (
        <Notification type={condition.class}>
          This vehicle has been marked as <b>{condition.name}</b>.
        </Notification>
      );
    }
    return null;
  }

  render() {
    if (!this.state.vehicle) {
      return (
        <Section>
          <Loader fullwidth />
        </Section>
      );
    }

    return (
      <RouteWrapper
        title={this.state.vehicle.registration || 'Unknown Registration'}
        requireAuth
        requirePermission="MANAGE_VEHICLES"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/vehicles', text: 'Vehicles' },
          {
            link: '/settings/vehicles/:id',
            text: this.state.vehicle.registration || 'Vehicle',
          },
        ]}
        loading={this.props.isFetching}
        error={!this.state.ready && this.props.error}
        ready={this.state.ready}
      >
        <HeadingSection
          title={this.state.vehicle.registration}
          subtitle={
            <Link
              to={`/settings/vehicles/types/${
                this.state.vehicle.vehicle_type_id
              }`}
            >
              {this.state.vehicle.vehicle_type_name}
            </Link>
          }
          image={
            <span className="avatar image is-64x64">
              <img src={this.state.vehicle.vehicle_type_image} />
            </span>
          }
          controls={
            !!this.state.revisionId
              ? []
              : [
                  <Permission key="delete" require="MANAGE_DELETIONS">
                    <div className="level-right">
                      <IconButton
                        link={`/settings/vehicles/${this.state.id}/delete`}
                        className="is-danger"
                        icon="trash"
                      >
                        Delete
                      </IconButton>
                    </div>
                  </Permission>,
                ]
          }
        />
        <Section>
          <div className="columns is-multiline">
            <div className="column is-12-desktop is-7-widescreen">
              {this.renderCondition()}
              <VehicleUpdateForm
                id={this.state.id}
                item={this.state.vehicle}
                disable={!!this.state.revisionId}
                onUpdate={() => {
                  window.history.back();
                }}
              />
            </div>
            <div className="column is-12-desktop is-5-widescreen">
              <NoteList resource="vehicles" id={this.state.id} />
            </div>
          </div>
        </Section>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = ({
  vehicles: { vehicles, lastVehicle, isFetching, error },
}) => ({
  vehicles,
  lastVehicle,
  isFetching,
  error,
});

export default connect(mapStateToProps)(Route);
